// Filtre meniu ROTY FOOD — izolat. Clasificare STRICT din datele existente
// (ingrediente + alergeni + eticheta „de post” a produsului). Nu inventează
// categorii; produsele care nu pot fi clasificate sigur nu primesc niciun tag.

const norm = (s) =>
  (s || "")
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

// Cuvinte-cheie clare de carne/pește din ingredientele existente.
const MEAT_FISH = [
  "salam",
  "cabanos",
  "sunca",
  "bacon",
  "piept de pui",
  "carne",
  "mici",
  "carnat",
  "carnaciori",
  "snitel",
  "ton",
  "aripioare",
  "crispy",
  "nuggets pui",
];

// Returnează tag-urile dietetice sigure ale unui produs.
export const getDietTags = (p) => {
  const tags = [];

  // De post: EXCLUSIV produsele marcate explicit de client (postOnly: true),
  // chiar dacă nu au încă ingrediente completate (ex. Sandwich vegetal).
  if (p.postOnly) tags.push("post");

  const ing = norm(p.ingredients || p.description || "");

  // Fără informații de ingrediente sau produs ambiguu → nu clasificăm.
  if (!ing || ing.includes("orice model")) return tags;

  const allergens = Array.isArray(p.allergens) ? p.allergens.map(norm) : null;
  const traces = Array.isArray(p.traces) ? p.traces.map(norm) : [];
  const hasMeat = MEAT_FISH.some((k) => ing.includes(k));

  // Vegetarian: fără carne/pește (lactate/ouă permise).
  if (!hasMeat) tags.push("vegetarian");

  // Fără gluten: alergeni declarați, fără gluten în alergeni și fără urme de gluten.
  if (allergens !== null && !allergens.includes("gluten") && !traces.includes("gluten")) {
    tags.push("gluten-free");
  }

  return tags;
};

export const matchesSearch = (p, q) => {
  const query = norm(q).trim();
  if (!query) return true;
  return norm(p.name).includes(query);
};

export const matchesFilters = (p, active) => {
  if (!active || active.length === 0) return true;
  const tags = getDietTags(p);
  return active.every((f) => tags.includes(f));
};
